// extracted by mini-css-extract-plugin
export default {"container":"GameList_container__Vm8uC","list":"GameList_list__Pwy9L"};